/* WUFFLYZ PDP behaviour: card strip, accordions, gallery, variant selection, AJAX add to cart (Dawn cart drawer aware), sticky mobile ATC. */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];

  /* Card strips */
  $$('[data-component=strip]').forEach(sec => {
    const el = $('.wf-strip', sec), cards = $$('.wf-card', el), dots = $('.wf-dots', sec);
    if (!cards.length) return;
    cards.forEach((_, i) => { const d = document.createElement('span'); d.className = 'wf-dot' + (i ? '' : ' wf-is-active'); dots.appendChild(d); });
    const w = () => cards[0].getBoundingClientRect().width + 20;
    $('[data-strip-prev]', sec).addEventListener('click', () => el.scrollBy({ left: -w(), behavior: 'smooth' }));
    $('[data-strip-next]', sec).addEventListener('click', () => el.scrollBy({ left: w(), behavior: 'smooth' }));
    el.addEventListener('scroll', () => { const i = Math.round(el.scrollLeft / w()); $$('.wf-dot', dots).forEach((d, j) => d.classList.toggle('wf-is-active', j === i)); }, { passive: true });
  });

  /* Purchase */
  function initPurchase() {
  const sec = $('[data-component=purchase]'); if (!sec || sec.dataset.wfInit) return; sec.dataset.wfInit = '1';
  const form = $('[data-product-form]', sec);
  const variants = JSON.parse($('[data-variants]', sec).textContent);
  const idInput = $('[data-variant-id]', sec);
  const qtyInput = $('[data-qty-input]', sec);
  const atc = $('[data-atc]', sec), atcLabel = $('[data-atc-label]', sec), atcPrice = $('[data-atc-price]', sec);
  /* Money: derive symbol, separators and decimals from a server-rendered sample of 1234567 minor units (works with Markets currencies) */
  const sample = sec.dataset.moneySample || '$12,345.67';
  const fmt = cents => {
    const m = sample.match(/^(.*?)(\d[\d., ' ]*\d)(.*)$/);
    if (!m) return (cents / 100).toFixed(2);
    const pre = m[1], post = m[3], digits = m[2];
    const decMatch = digits.match(/[.,](\d{1,2})$/);
    const decimals = decMatch ? decMatch[1].length : 0;
    const decSep = decMatch ? digits[digits.length - decimals - 1] : '';
    const intPart = decMatch ? digits.slice(0, -decimals - 1) : digits;
    const thouSep = intPart.replace(/\d/g, '')[0] || '';
    const n = (cents / 100).toFixed(decimals);
    let [i, d] = n.split('.');
    i = i.replace(/\B(?=(\d{3})+(?!\d))/g, thouSep);
    return pre + i + (decimals ? decSep + d : '') + post;
  };

  /* Gallery */
  const imgs = $$('.wf-gal__img', sec), thumbs = $$('.wf-thumb', sec); let cur = 0;
  const show = i => { if (!imgs.length) return; cur = (i + imgs.length) % imgs.length; imgs.forEach((im, j) => im.hidden = j !== cur); thumbs.forEach((t, j) => { t.classList.toggle('wf-is-active', j === cur); t.setAttribute('aria-selected', String(j === cur)); }); };
  thumbs.forEach(t => t.addEventListener('click', () => show(+t.dataset.index)));
  const prev = $('[data-gal-prev]', sec), next = $('[data-gal-next]', sec);
  if (prev) prev.addEventListener('click', () => show(cur - 1));
  if (next) next.addEventListener('click', () => show(cur + 1));
  let tx = 0; const gm = $('.wf-gal__main', sec);
  gm.addEventListener('touchstart', e => tx = e.touches[0].clientX, { passive: true });
  gm.addEventListener('touchend', e => { const dx = e.changedTouches[0].clientX - tx; if (Math.abs(dx) > 40 && imgs.length > 1) show(cur + (dx < 0 ? 1 : -1)); });

  /* Variants */
  const options = $$('.wf-option', sec);
  const selected = () => options.map(o => $('[aria-checked=true]', o)?.dataset.optionValue);
  function currentVariant() { const s = selected(); return variants.find(v => s.every((val, i) => v['option' + (i + 1)] === val)); }
  function addonTotal() { return $$('[data-addon-id]:checked', sec).reduce((t, i) => t + Number(i.dataset.price), 0); }
  function refresh() {
    const v = currentVariant(); const q = Math.max(1, Number(qtyInput.value) || 1);
    if (!v) { atc.disabled = true; atcLabel.textContent = 'Inte tillgänglig'; atcPrice.textContent = ''; return; }
    idInput.value = v.id;
    $('[data-price-now]', sec).textContent = fmt(v.price);
    const was = $('[data-price-was]', sec), save = $('[data-price-save]', sec);
    if (was) { const on = v.compare_at_price > v.price; was.hidden = !on; save.hidden = !on; if (on) { was.textContent = fmt(v.compare_at_price); save.textContent = 'Spara ' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%'; } }
    atc.disabled = !v.available; atcLabel.textContent = v.available ? (atc.dataset.label || 'Lägg i varukorgen') : 'Slutsåld';
    atcPrice.textContent = fmt((v.price + addonTotal()) * q);
    const t = thumbs.find(t => (t.dataset.variantIds || '').split(' ').includes(String(v.id))); if (t) show(+t.dataset.index);
    const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    document.dispatchEvent(new CustomEvent('wufflyz:refresh', { detail: { variant: v } }));
  }
  atc.dataset.label = atcLabel.textContent.trim();
  options.forEach(o => $$('[role=radio]', o).forEach(b => b.addEventListener('click', () => {
    $$('[role=radio]', o).forEach(x => x.setAttribute('aria-checked', 'false')); b.setAttribute('aria-checked', 'true');
    const lab = $('[data-option-label]', o); if (lab) lab.textContent = b.dataset.optionValue; refresh();
  })));
  $$('[data-qty]', sec).forEach(b => b.addEventListener('click', () => { qtyInput.value = Math.min(10, Math.max(1, Number(qtyInput.value) + Number(b.dataset.qty))); refresh(); }));
  qtyInput.addEventListener('change', refresh);
  $$('[data-addon-id]', sec).forEach(i => i.addEventListener('change', refresh));

  /* AJAX add to cart; opens Dawn's cart drawer / notification when present, else falls back to the cart page */
  form.addEventListener('submit', async e => {
    e.preventDefault(); const v = currentVariant(); if (!v || !v.available) return;
    const fb = $('[data-cart-feedback]', sec); const q = Math.max(1, Number(qtyInput.value) || 1);
    const items = [{ id: v.id, quantity: q }, ...$$('[data-addon-id]:checked', sec).map(i => ({ id: Number(i.dataset.addonId), quantity: 1 }))];
    const drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    const body = { items };
    if (drawer && drawer.getSectionsToRender) { body.sections = drawer.getSectionsToRender().map(s => s.id).join(','); body.sections_url = location.pathname; }
    atc.disabled = true; atcLabel.textContent = 'Lägger till…';
    try {
      const r = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Kunde inte lägga i varukorgen');
      fb.textContent = 'Tillagd i varukorgen.'; fb.classList.add('wf-is-visible'); atcLabel.textContent = 'Tillagd ✓';
      document.dispatchEvent(new CustomEvent('wufflyz:cart:added', { detail: { items } }));
      if (drawer && drawer.renderContents && data.sections) { drawer.renderContents(data); }
      else {
        const cart = await (await fetch('/cart.js')).json();
        $$('.cart-count-bubble span[aria-hidden], [data-cart-count]').forEach(el => { el.textContent = cart.item_count; });
        if (!drawer) setTimeout(() => { location.href = '/cart'; }, 600);
      }
      setTimeout(refresh, 1600);
    } catch (err) { fb.textContent = err.message; fb.classList.add('wf-is-visible'); refresh(); }
  });

  /* Sticky mobile add-to-cart */
  const sticky = $('[data-sticky-atc]'); if (sticky) {
    sticky.hidden = false;
    new IntersectionObserver(([e]) => sticky.classList.toggle('wf-is-visible', !e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 }).observe(form);
    const sb = $('[data-sticky-atc-btn]', sticky), sp = $('[data-sticky-price]', sticky);
    sb.addEventListener('click', () => { form.scrollIntoView({ behavior: 'smooth', block: 'center' }); setTimeout(() => form.requestSubmit(), 500); });
    document.addEventListener('wufflyz:refresh', e => { sp.textContent = fmt(e.detail.variant.price); sb.disabled = !e.detail.variant.available; });
  }
  refresh();
  }
  initPurchase();
  document.addEventListener('shopify:section:load', initPurchase);
})();
